<template>
  <div class="m-view-block">
    <h2>最新区块</h2>
    <div class="block-area table-shadow">
      <div
        class="block-item flex-left"
        v-for="(item, index) in block.list"
        :key="index"
      >
        <router-link
          :to="{ path: '/blockdetail', query: { height: item.height } }"
          class="height-box"
          >{{ item.height }}</router-link
        >
        <div class="detail">
          <p>
            <span style="margin-right: 10px">区块哈希：</span>
            <router-link
              :to="{ path: '/blockdetail', query: { height: item.height } }"
              class="light hash"
              >{{ filterHash(item.hash, 10) }}</router-link
            >
          </p>
          <p>
            <span class="light txcount">{{ item.txCount }} 笔数据</span>
            <Count class="count-down grey" :time="item.blockTime"></Count>
          </p>
        </div>
      </div>
      <router-link to="/block" class="viewall-btn flex-center"
        >查看全部</router-link
      >
    </div>
  </div>
</template>

<script setup>
import { watch, computed } from "vue";
import { filterHash } from "@/utils/filters";
import HomeMixins from "@/mixins/home";
import Count from "@/components/common/Count.vue";
import Store from "@/store/index";

const { block, checkNewBlock } = HomeMixins();
const maxHeight = computed(() => Store.state.maxHeight);

watch(
  maxHeight,
  () => {
    checkNewBlock();
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.m-view-block {
  h2 {
    padding: 30px 0 20px 12px;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
    color: $black;
    line-height: 20px;
  }
  .block-area {
    background: $white;
    .block-item {
      height: 80px;
      padding: 20px;
      border-bottom: 1px solid $border;
      .height-box {
        height: 40px;
        min-width: 75px;
        padding: 0 10px;
        line-height: 40px;
        text-align: center;
        color: $white;
        font-size: 14px;
        background: $blue;
        border-radius: 2px;
      }
      .detail {
        margin-left: 15px;
        color: $black;
        font-size: 12px;
        line-height: 20px;
        p {
          line-height: 22px;
        }
        .txcount {
          display: inline-block;
          min-width: 5em;
          margin-right: 10px;
        }
        .grey {
          color: $grey;
        }
      }
    }
    .viewall-btn {
      height: 60px;
      font-size: 14px;
      color: $orange;
    }
  }
}
</style>